import { Injectable, EventEmitter, inject } from '@angular/core';
import { MenuItem, menuItems, MenuList, subCategoryMgnt } from '../nav-bar/menu';
import { IUser, User } from '@app/store/user';
import { PrivilegesService } from '@shared/privileges/privileges.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private readonly privilegesService = inject(PrivilegesService);
  items: MenuList;
  responsive: EventEmitter<any>;
  constructor(
  ) {
    this.items = menuItems;
    this.responsive = new EventEmitter<boolean>();
  }

  public setPrivileges(user: IUser) {
    if (user) {
      this.items.admin.active = this.privilegesService.isCategoryUser(user);
    }
  }

  public toggleResponsive(state: boolean) {
    this.responsive.emit(state);
  }
}
